import { httpClient } from '@/lib/api/httpClient'

export const ordersApi = {
  fetchOrders: async (vendorId: string, params: { type?: string; status?: string; page?: number; limit?: number }) => {
    const response = await httpClient.get(`/vendors/${vendorId}/orders`, { params })
    return response.data?.data
  },

  fetchOrderDetail: async (vendorId: string, type: string, orderId: string) => {
    const response = await httpClient.get(`/vendors/${vendorId}/orders/${type}/${orderId}`)
    return response.data?.data?.order
  },

  updateOrderStatus: async (vendorId: string, type: string, orderId: string, status: string, reason?: string) => {
    const response = await httpClient.patch(`/vendors/${vendorId}/orders/${type}/${orderId}/status`, { status, reason })
    return response.data?.data
  },

  pollNewOrders: async (vendorId: string) => {
    const response = await httpClient.get(`/vendors/${vendorId}/orders/poll`)
    return response.data?.data
  },
}
